export const getBorder = (colors, border) => {
  if (border === undefined) {
    return undefined;
  }
  return border === 'none' ? '0' : `1px solid ${colors[border]}`;
};